<script setup>
import { defineProps, defineEmits, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilObject from "@/utils/UtilObject";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "visualizandoDadoNotaFiscalEmitida",
    "dadoOriginal"
]);

const emits = defineEmits([
    "update:alteraVisualizandoDadoNotaFiscalEmitida",
]);

//==================================================================//
//============================== Dado ==============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//========== Altera Visualizando Dado Nota Fiscal Emitida ==========//
//==================================================================//

const alteraVisualizandoDadoNotaFiscalEmitida = (update) =>{

    emits('update:alteraVisualizandoDadoNotaFiscalEmitida',update);

};

//==================================================================//
//===================== Altera Dado de Compra ======================//
//==================================================================//

const alteraDado = (update = {})=>{

    dado.value = UtilObject.merge(dado.value, update);

};

//==================================================================//
//=================== Altera Conta a Receber =======================//
//==================================================================//

const alteraContaAReceber = (update)=>{

    let contasAReceber = dado?.value?.contasAReceber?.map((contaAReceber)=>{

        if(contaAReceber.id != update.id){
            return contaAReceber;
        }

        return UtilObject.merge(contaAReceber,update);

    });

    alteraDado({
        contasAReceber: contasAReceber
    });

};

//==================================================================//
//========================= Prepara Dado ===========================//
//==================================================================//

const preparaDado = (dado = {})=>{

    let contasAReceber = dado?.parcelas?.map(({contaAReceber})=>{

        let recebimentos = contaAReceber?.recebimentos?.map((recebimento)=>{

            let recebimentoTipo = recebimento?.tipo?.replace("Vinculo","Adiantamento");

            let recebimentoFormatado = {
                id: recebimento?.id || "",
                sequencia: recebimento?.sequencia || "",
                tipo: recebimentoTipo || "",
                status: recebimento?.status || "",
                contaFinanceiraNome: recebimento?.contaFinanceira?.nome || "",
                dataCriacao: recebimento?.dataCriacaoFormatada || "",
                dataVencimento: recebimento?.dataVencimentoFormatada || "",
                valorRecebimento: recebimento?.valorRecebimento || "",
                jobParcelaCodigo: recebimento?.jobParcela?.codigo || "",
                jobParcelaSequencia: recebimento?.jobParcela?.sequencia || "",
                jobParcelaTipo: recebimento?.jobParcela?.tipo || "",
                jobParcelaDescricao: recebimento?.jobParcela?.descricao || "",
                vinculoContaAReceberAvulsaCodigo: recebimento?.vinculo?.contaAReceberAvulsa?.codigo || "",
                vinculoRecebimentoSequencia: recebimento?.vinculo?.recebimento?.sequencia || "",
                vinculoContaAReceberAvulsaFormatado: "",
            };

            if(recebimentoFormatado?.vinculoContaAReceberAvulsaCodigo || recebimentoFormatado?.vinculoRecebimentoSequencia){
                recebimentoFormatado.vinculoContaAReceberAvulsaFormatado = `${recebimentoFormatado?.vinculoContaAReceberAvulsaCodigo} - ${recebimentoFormatado?.vinculoRecebimentoSequencia}`
            }

            return recebimentoFormatado;


        });

        return {
            id: contaAReceber?.id || "",
            aberto: false,
            codigo: contaAReceber?.codigo || "",
            status: contaAReceber?.status || "",
            valorOriginal: contaAReceber?.valorOriginal || 0,
            valorRecebido: contaAReceber?.valorRecebido || 0,
            valorParaReceber: contaAReceber?.valorParaReceber || 0,
            dataVencimento: contaAReceber?.dataVencimentoFormatada || "",
            recebimentos: recebimentos || []
        };

    });

    dado = {
        id: dado?.id || "",
        origem: dado?.origem || "",
        numero: dado?.numero || "",
        chaveAcesso: dado?.chaveAcesso || "",
        plugNotasID: dado?.plugNotasID || "",
        clienteNome: dado?.cliente?.nome || "",
        jobCodigo: dado?.job?.codigo|| "",
        valorOriginal: dado?.valorOriginal|| 0,
        valorRecebido: dado?.valorRecebido|| 0,
        valorParaReceber: dado?.valorParaReceber|| 0,
        dataCriacao: dado?.dataCriacaoFormatada || "",
        contasAReceber: contasAReceber || []
    }

    alteraDado(dado);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = ()=>{

    preparaDado(UtilObject.clone(props?.dadoOriginal));

}

//==================================================================//
//============ Watch => visualizandoDadoNotaFiscalEmitida ==========//
//==================================================================//

watch(()=> props.visualizandoDadoNotaFiscalEmitida, () => {

    if(props.visualizandoDadoNotaFiscalEmitida == true){
        preparaModal();
    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.visualizandoDadoNotaFiscalEmitida"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="dado"
                    @update:alteraVisualizandoDadoNotaFiscalEmitida="alteraVisualizandoDadoNotaFiscalEmitida"
                ></BarraNavegacao>

                <DadoConteudo
                    :dado="dado"
                    @update:alteraContaAReceber="alteraContaAReceber"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

